<template>
  <div class="commonTable">
    <el-table :data="dataList" border style="width: 100%">
      <el-table-column v-if="selection" type="selection" width="55"></el-table-column>
      <el-table-column
        v-for="(item, index) in headList"
        :key="index"
        :prop="item.value"
        :label="item.label"
        :width="item.width"
        :align="align"
      >
        <template slot-scope="scope">
          <span v-if="item.value == 'status' && item.type == 'verify'">
            {{ scope.row[item.value] |
            getStatusCn(that)
            }}
          </span>
          <span v-else-if="item.value == 'status' && item.type == 'ifPass'">
            {{ scope.row[item.value] |
            getPassOrRefuse(that)
            }}
          </span>
          <span v-else>{{ scope.row[item.value] }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="buttonList.length > 0" label="操作" :width="btnWidth" align="center">
        <template slot-scope="scope">
          <span v-for="(item, index) in buttonList" :key="index" class="btn">
            <span v-if="item.type == 'check'" @click="check(scope.row)" class="checkBtn">
              <i class="el-icon-view"></i>
              {{ item.name }}
            </span>
            <span v-else-if="item.type == 'edit'" @click="edit(scope.row)" class="checkBtn">
              {{ item.name
              }}
            </span>
            <span v-else-if="item.type == 'del'" @click="del(scope.row)" class="checkBtn">
              {{ item.name
              }}
            </span>
            <!-- 项目申报查看按钮 -->
            <span
              v-else-if="item.type == 'applyCheck' && (scope.row.status =='REVIEW'||scope.row.status == 'REVIEW_PASS')"
              @click="check(scope.row)"
              class="checkBtn"
            >
              <i class="el-icon-view"></i>
              {{ item.name}}
            </span>
            <!-- 项目申报修改按钮 -->
            <span
              v-else-if="item.type == 'applyEdit' && (scope.row.status == 'INIT'||scope.row.status == 'REJECT')"
              @click="check(scope.row)"
              class="checkBtn"
            >
              <i class="el-icon-edit"></i>
              {{ item.name}}
            </span>
            <span
              v-else-if="item.type == 'other'"
              @click="other(scope.row, item)"
              class="checkBtn"
              :class="item.btn ? 'btn' : ''"
            >
              {{
              item.name }}
            </span>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :background="background"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
      :current-page="currentPage"
      @size-change="onSizeChange"
      @current-change="currentChange"
    />
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    headList: {
      type: Array,
      default: () => {
        return [
          // { label: '填报原因', value: 'reason' }
        ];
      }
    },
    dataList: {
      type: Array,
      default: () => {
        return [
          // { reason: '90', date: '2024-03-23', type: '审核通过' }
        ];
      }
    },
    buttonList: {
      type: Array,
      default: () => {
        return [
          // {
          //     name: '查看',
          //     type: 'check'
          // }
        ];
      }
    },
    align: {
      type: String,
      default: "center"
    },
    selection: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    btnWidth: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      that: this,
      statusList: [
        {
          value: "INIT",
          name: "待提交"
        },
        {
          value: "REVIEW",
          name: "审核中"
        },
        {
          value: "REVIEW_PASS",
          name: "审核通过"
        },
        {
          value: "REJECT",
          name: "审核不通过"
        }
      ], // 审核的状态
      ifPassList: [
        {
          value: "COMMITTED",
          name: "提交"
        },
        {
          value: "AGREE",
          name: "审核通过"
        },
        {
          value: "REJECT",
          name: "审核不通过"
        }
      ]
    };
  },
  filters: {
    getStatusCn(val, that) {
      if (val) {
        // console.log(that.statusList.filter(el => el.value == val)[0].name)
        return that.statusList.filter(el => el.value == val)[0].name;
      } else {
        return;
      }
    },
    getPassOrRefuse(val, that) {
      if (val) {
        return that.ifPassList.filter(el => el.value == val)[0].name;
      } else {
        return;
      }
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    currentChange(current) {
      this.$emit("currentChange", { currentPage: current });
    },
    onSizeChange(pageSize) {
      this.$emit("onSizeChange", { pageSize });
    },
    check(item) {
      this.$emit("check", item);
    },
    edit(item) {
      this.$emit("edit", item);
    },
    del(item) {
      this.$emit("del", item);
    },
    other(row, item) {
      this.$emit("other", row, item);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common.less";

.commonTable {
  width: 100%;
  min-height: 300px;
  margin-top: 25px;

  .btn {
    // margin: 0 5px;
    cursor: pointer;

    .checkBtn {
      color: #2d50a1;
      margin: 0 4px;
    }

    .btn {
      color: #fff;
      padding: 2px 4px;
      border-radius: 4px;
      .bc();
    }

    /deep/ .el-icon-view {
      color: #2d50a1;
    }
  }

  /deep/ .el-pagination {
    text-align: center;
    margin: 25px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/commonTable.vue